import { cn } from '@mntn-dev/ui-utilities'

import type { ButtonSize } from '../buttons/button.tsx'
import { getButtonStyles } from '../buttons/styles.ts'

export type RadioButtonTheme = 'positive' | 'info'

const themeSelectedClassNameMap: Record<RadioButtonTheme, string> = {
  positive: 'data-checked:border-positive data-checked:[&_svg]:text-positive',
  info: 'data-checked:border-info-light data-checked:[&_svg]:text-info-light',
}

export type RadioButtonStyleProps = {
  size: ButtonSize
  theme: RadioButtonTheme
}

const getThemeClassName = (theme: RadioButtonTheme) => {
  return cn(themeSelectedClassNameMap[theme])
}

export const getRadioButtonClassName = ({
  size,
  theme,
}: RadioButtonStyleProps) =>
  cn(
    'cursor-pointer data-checked:border data-checked:border-solid group-data-[selected-value]:not-data-checked:text-disabled',
    'group-data-[selected-value]:not-data-checked:bg-surface-primary-disabled group-data-[selected-value]:not-data-checked:border-subtle',
    getButtonStyles(size, 'secondary'),
    getThemeClassName(theme)
  )
